import {useEffect, useState} from "react";
import "./Slider.css";

function Slider({value, setValue, title, required, initialError, id, min, max, step = 1, updateObject}) {
    const [error, setError] = useState(initialError);
    useEffect(() => {setError(initialError);}, [initialError]);

    function handleChange(event) {
        if (typeof setValue === 'function') {
            setValue(event.target.value);
        }

        if (typeof updateObject === 'function') {
            updateObject(id, event.target.value);
        }
    }

    return (
        <div>
            <div className="flex justify-between">
                <label htmlFor={id} className="block font-medium p-1">{title}{required ? "*" : ""}</label>
                <input
                    className="border border-gray-300 rounded-lg focus:ring-primary focus:border-primary p-1 w-16"
                    type="number" name={id} min={min} max={max} step={step} value={value}
                    onChange={handleChange} required={required}/>
            </div>
            <input id={id} type="range" min={min} max={max} value={value}
                   onChange={handleChange} step={step} required={required}
                   className="w-full h-2 md:h-1 slider-lg bg-gray-200 rounded-lg appearance-none cursor-pointer accent-primary-light hover:accent-primary"
            />

        </div>
    );
}

export default Slider;